export const profilePath = (Urls) => Urls['users:profile']()
export const profileOrdersPath = (Urls) => Urls['users:profile']('orders')
export const profileProductsPath = (Urls) => Urls['users:profile']('products')
export const profileReferralPath = (Urls) => Urls['users:profile']('referral')

export const COUPON_COOKIES = 'coupon'
